import { useQuery } from '@tanstack/react-query';

import { queryKeys } from 'api/config';
import { useQueryHTTPRequest } from 'shared_DEPRECATED/hooks';
import { LinkPreview } from 'types/common';

type TUseLinkPreviewQuery = {
  url: string;
  options?: any;
};

export const useLinkPreviewQuery = ({ url, options }: TUseLinkPreviewQuery) => {
  const { request } = useQueryHTTPRequest();

  return useQuery<LinkPreview>(
    [queryKeys.linkPreview, url],
    async () => {
      const encodedUrl = encodeURIComponent(url);

      return request({
        url: `/api/link-preview?url=${encodedUrl}`,
      });
    },
    { enabled: !!url, useErrorBoundary: false, ...options }
  );
};
